import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/modules/services/toast/toast.service';

@Component({
  selector: 'app-import-modal',
  templateUrl: './import-modal.component.html',
  styleUrls: ['./import-modal.component.scss']
})
export class ImportModalComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef | null = null;

  fileNames: string[] = [];
  selectedFile: File | null = null;
  maxFileSize: number = 25 * 1024 * 1024;
  file: File | null = null;
  filesInfo:any
  fileSize:string = '';
  isServicosIniciais = false;
  isFrenteConservacao = false;
  isServicoAmpliacao = false;
  constructor(
    private toastService: ToastService,
    private dialogRef: MatDialogRef<ImportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isServicosIniciais = this.data?.isServicosIniciais;
    this.isFrenteConservacao = this.data?.isFrenteConservacao;
    this.isServicoAmpliacao = this.data?.isServicoAmpliacao;
  }
  ngOnInit(): void {

  }

  onSubmit() {
    const data = {
      ...this.filesInfo
    }
      this.dialogRef.close(data)
  }

  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (file.size > this.maxFileSize) {
      const maxSize = this.maxFileSize / 1024 / 1024;
      return this.toastService.showError(
        `O tamanho do arquivo selecionado é maior do que o permitido. Selecione arquivos de até 25MB de tamanho. .`
      );
    }

    this.file = file;
    this.selectedFile = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64File: any = reader.result;
      const fileInfos: { name: string; size: number; type: string; base64: string; file: any }[] = [];

      fileInfos.push({
        name: file.name,
        size: file.size,
        type: file.type,
        base64: base64File,
        file: file
      });
      this.filesInfo = {
        name: file.name,
        size: file.size,
        type: file.type,
        base64: base64File,
        file: file
      }
      this.fileSize = `${(file.size / 1024).toFixed(2)} KB`;
      this.fileNames = [file.name];
    };
  }
  triggerFileInputClick(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }
  back() {
    this.dialogRef.close()
  }
  removeFile(): void {
    this.filesInfo = null;
    this.fileSize = '';
  }
  downloadModel(){
   let fileName = '';

  if (this.isServicosIniciais) {
    fileName = 'template_importacao_servicos_iniciais v1.xlsx';
  } else if (this.isFrenteConservacao) {
    fileName = 'Template para Importar _Conservacao.xlsx';
  } else if (this.isServicoAmpliacao) {
    fileName = 'Template_importacao_servicos_ampliacao.xlsx';
  }else {
    fileName = 'templates_importação_rodovias_segmentos.xlsx';
  }

  const fileUrl = `assets/templates/${fileName}`;
  this.downloadFile(fileUrl, fileName);
  }
  downloadFile(url: string, filename: string) {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.target = '_blank'; // útil caso não seja possível baixar, o arquivo será aberto
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
}
